import React from 'react';
import Modal from './Modal.js';
import Text from '../Text.js';
import DateInput from '../../components/TextFields/DateInput.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
const statusMap = {
  0: 'Pending',
  1: 'Active',
  2: 'Account Disabled',
  3: 'Parental Leave',
  4: 'Leave of Absence',
  5: 'Temporary Lay Off',
  6: 'Disability',
  7: 'Strike',
  8: 'Late Applicant',
  9: 'Terminated',
  10: 'Approved Leave',
  11: 'Survivor Benefits',
  12: 'Severance',
  'Pending': 0,
  'Active': 1,
  'Account Disabled': 2,
  'Parental Leave': 3,
  'Leave of Absence': 4,
  'Temporary Lay Off': 5,
  'Disability': 6,
  'Strike': 7,
  'Late Applicant': 8,
  'Terminated': 9,
  'Approved Leave': 10,
  'Survivor Benefits': 11,
  'Severance': 12
};

/**
 * 
 * @returns 
 */
const EffectiveDateModal = ({
  open,
  onClick,
  onClose,
  setEffectiveDate,
  loader,
  effectiveDate,
  effectiveDateError,
  employeeMeta,
  isMasterProfile = false,
  setExpectedLeaveReturnDate,
  expectedLeaveReturnDate,
  expectedLeaveReturnDateError
}) => {
  const showExpectedLeaveReturnDate = isMasterProfile && (!employeeMeta.activeStatusRecord || statusMap[employeeMeta.activeStatusRecord.status] !== employeeMeta.status) && ['Parental Leave', 'Leave of Absence', 'Temporary Lay Off', 'Disability', 'Strike', 'Approved Leave', 'Severance'].includes(employeeMeta.status);
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose,
    title: i18n.t(tokens.titles.setEffectiveDate),
    primaryButton: {
      label: "Submit",
      onClick: onClick
    },
    loader: loader
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.pleaseProvideEffectiveDate)), /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.effectiveDate),
    value: effectiveDate,
    onChange: e => setEffectiveDate(e.target.value),
    error: Boolean(effectiveDateError),
    helperText: effectiveDateError,
    fullWidth: true,
    required: true
  }), showExpectedLeaveReturnDate ? /*#__PURE__*/React.createElement(DateInput, {
    label: "Expected Return Date",
    value: expectedLeaveReturnDate,
    onChange: e => setExpectedLeaveReturnDate(e.target.value),
    error: Boolean(expectedLeaveReturnDateError),
    helperText: expectedLeaveReturnDateError,
    fullWidth: true,
    required: true
  }) : null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    margin: "10px 0 0 0"
  }, i18n.t(tokens.labels.changesAppliedOnEffectiveDate)));
};
export default EffectiveDateModal;